"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _socialIcon = _interopRequireDefault(require("./social-icon"));

require("./share-button.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var emailBase = 'mailto:';
var facebookBase = 'https://www.facebook.com/sharer/sharer.php';
var linkedinBase = 'https://www.linkedin.com/shareArticle';
var pinterestBase = 'http://pinterest.com/pin/create/button/';
var tumblrBase = 'http://www.tumblr.com/share/link';
var twitterBase = 'https://twitter.com/intent/tweet'; // Simple helper to convert key-values into an url-safe query string, dropping
// any keys that have no value.

function queryString(map) {
  var encodedParams = _lodash["default"].chain(map).omitBy(_lodash["default"].isEmpty).map(function (value, key) {
    return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
  }).join('&').value();

  return "?".concat(encodedParams);
}
/**
 * A Glowforge-standard social media site icon that can be clicked to launch a
 * popup prompting the user to share some content to that social site.
 * Depending on the site, different properties will be used or ignored. The
 * most commonly used properties are `url`, `hashtag`, and `text`. This
 * component will evolve to match Glowforge's standard for how share prompts
 * work on each site, as well as changes to each site's API, so clients should
 * pass data for as many props as possible to take advantage of new
 * functionality with future releases.
 *
 * @param site - which social site this button is for, e.g. 'facebook', 'twitter'
 * @param url - the url of the content being shared e.g. 'https://glowforge.com/akkika'
 * @param hashtag - do not include the # character e.g. 'glowforge'
 * @param text - the primary short-text to use as default content for the user's post
 * @param quote - a quote from Glowforge to include alongside the link iteslf
 * @param image - an image to share (only currently supported by pinterest)
 * @param props.size - passed on to SocialIcon - standard sizes small, medium, or large
 * @param props.appearance - passed on to SocialIcon - available styles square, round, clear
 * @returns {*}
 * @constructor
 */


var ShareButton = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ShareButton, _React$PureComponent);

  var _super = _createSuper(ShareButton);

  function ShareButton() {
    var _this;

    _classCallCheck(this, ShareButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "showInWindow", function (event) {
      var site = _this.props.site;
      event.preventDefault();
      window.open(_this.shareUrl(), "".concat(site, "-share-popup"), 'width=640,height=400');
    });

    return _this;
  }

  _createClass(ShareButton, [{
    key: "shareUrl",
    value: function shareUrl() {
      var _this$props = this.props,
          site = _this$props.site,
          url = _this$props.url,
          hashtag = _this$props.hashtag,
          text = _this$props.text,
          quote = _this$props.quote,
          image = _this$props.image;

      switch (site) {
        case 'email':
          return emailBase + queryString({
            subject: text,
            body: url
          });

        case 'facebook':
          return facebookBase + queryString({
            u: url,
            hashtag: "#".concat(hashtag),
            quote: quote
          });

        case 'linkedin':
          return linkedinBase + queryString({
            mini: 'true',
            url: url,
            summary: text,
            source: 'Glowforge'
          });

        case 'pinterest':
          return pinterestBase + queryString({
            "do": 'buttonPin',
            media: image,
            url: url,
            description: text
          });

        case 'tumblr':
          return tumblrBase + queryString({
            url: url
          });

        case 'twitter':
          return twitterBase + queryString({
            url: url,
            text: text,
            hashtags: hashtag
          });

        default:
          return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "ShareButton"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: this.shareUrl(),
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: this.showInWindow
      }, /*#__PURE__*/_react["default"].createElement(_socialIcon["default"], this.props)));
    }
  }], [{
    key: "currentLocation",
    value: function currentLocation() {
      if (typeof window === 'undefined') {
        return null;
      }

      return _lodash["default"].get(window, ['location', 'href']);
    }
  }]);

  return ShareButton;
}(_react["default"].PureComponent);

_defineProperty(ShareButton, "propTypes", _objectSpread(_objectSpread({}, _socialIcon["default"].propTypes), {}, {
  url: _propTypes["default"].string,
  hashtag: _propTypes["default"].string,
  text: _propTypes["default"].string,
  quote: _propTypes["default"].string,
  image: _propTypes["default"].string,
  // Override `site` from `SocialIcon` to limit to the sites supported here.
  site: _propTypes["default"].oneOf(['email', 'facebook', 'linkedin', 'pinterest', 'tumblr', 'twitter']).isRequired
}));

_defineProperty(ShareButton, "defaultProps", {
  url: ShareButton.currentLocation(),
  hashtag: 'glowforge',
  text: null,
  quote: null,
  image: null
});

var _default = ShareButton;
exports["default"] = _default;